import { FC } from 'react';
import styled from 'styled-components';

type DivProps = {
  open: boolean;
} & React.HTMLProps<HTMLDivElement>;
/* eslint-disable @typescript-eslint/no-unused-vars */
const DivWithProps: FC<DivProps> = ({ open, ...props }) => {
  return <div {...props} />;
};
const Container = styled(DivWithProps)`
  @media (min-width: 900px) {
    position: sticky;
    top: 0;
    height: 100vh;
  }

  @media (max-width: 900px) {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 50;
    pointer-events: none;
  }
`;
const Background = styled(DivWithProps)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--gray-800);
  opacity: 0.4;
  pointer-events: painted;
  display: ${({ open }) => (open ? 'block' : 'none')};

  @media (min-width: 900px) {
    display: none;
  }
`;

const ContentContainer = styled(DivWithProps)`
  display: flex;
  flex-direction: column;
  background: white;
  right: ${({ open }) => (open ? '0' : '-100%')};
  height: 100%;
  pointer-events: painted;
  transition: 0.2s;
  overflow-y: auto;

  @media (max-width: 900px) {
    position: fixed;
    top: 0;
    bottom: 0;
    width: min(25rem, 100vw);
  }
`;

type Props = {
  open: boolean;
  close: () => void;
};
const NavDrawer: FC<Props> = ({ children, open, close }) => {
  return (
    <Container open={open}>
      <Background open={open} onClick={close} />
      <ContentContainer open={open}>{children}</ContentContainer>
    </Container>
  );
};

export default NavDrawer;
